import {alertService} from "@/services/alert/alert.service";
import {guestSettingCarService} from "@/services/guest/setting/car.service";

export default {
    data() {
        return {
            cars: [],
            carsReady: false,
            car: {},
            error: null,
            valid: false, // 予約入力フォームのバリデーションチェック
            regionList: [
                // 東北地方
                "宮城", "仙台", "青森", "弘前", "八戸", "岩手", "盛岡", "平泉", "秋田", "山形", "庄内", "福島", "会津", "郡山", "白河", "いわき",
                // 北海道地方
                "札幌", "函館", "旭川", "室蘭", "苫小牧", "釧路", "帯広", "北見", "知床",
                // 関東地方
                "水戸", "土浦", "つくば", "宇都宮", "那須", "とちぎ", "群馬", "高崎", "前橋", "千葉", "成田", "野田", "柏", "松戸", "習志野", "船橋", "市川", "袖ヶ浦", "市原", "大宮", "川口", "熊谷", "春日部", "越谷", "所沢", "川越", "品川", "世田谷", "足立", "江東", "葛飾", "練馬", "杉並", "板橋", "多摩", "八王子", "横浜", "川崎", "相模", "湘南", "山梨", "富士山",
                // 中部地方
                "新潟", "長岡", "上越", "長野", "松本", "諏訪", "富山", "石川", "金沢", "名古屋", "三河", "豊田", "岡崎", "尾張小牧", "一宮", "春日井", "豊橋", "静岡", "沼津", "伊豆", "浜松", "岐阜", "飛騨", "飛騨", "三重", "鈴鹿", "四日市", "伊勢志摩", "福井",
                // 近畿地方
                "大阪", "なにわ", "和泉", "堺", "京都", "奈良", "飛鳥", "滋賀", "和歌山", "神戸", "姫路",
                // 中国地方
                "広島", "福山", "鳥取", "島根", "出雲", "岡山", "倉敷", "山口", "下関",
                // 四国地方
                "徳島", "香川", "高松", "愛媛", "高知",
                // 九州地方
                "福岡", "北九州", "筑豊", "久留米", "佐賀", "長崎", "佐世保", "熊本", "大分", "宮崎", "鹿児島", "奄美",
                // 沖縄地方
                "沖縄"
              ],
        }
    },
    async mounted() {
        this.list$()
    },
    methods: {
        close() {
            this.$emit("updatePageClose");
        },
        async list$() {
            alertService.loading();
            this.carsReady = false
            await guestSettingCarService.list({
                paginate: 0,
                per_page: 10,
            }).then((response) => {
                this.cars = response.data
                this.carsReady = true
            }).catch((error) => {
                console.log(error)
            }).finally(() => {
                alertService.close();
            });
        },
        async store$() {
            if (!this.$refs.form.validate()) return
            alertService.loading();
            await guestSettingCarService.store(this.car)
                .then((response) => {
                    this.list$()
                }).catch((error) => {
                    alertService.close();
                    this.error = error.message
                    console.log(error)
                }).finally(() => {
                    this.$emit("updatePageClose");
                    alertService.close();
                });
        },
        async update$(id) {
            if (!this.$refs.form.validate()) return
            alertService.loading();
            await guestSettingCarService.update(id, this.car)
                .then((response) => {
                    this.list$()

                }).catch((error) => {
                    alertService.close();
                    this.error = error.message
                    console.log(error)
                }).finally(() => {
                    this.$emit("updatePageClose");
                    alertService.close();
                });

        },
        async delete$(id) {
            var callback = async () => {
                await guestSettingCarService.delete(id)
                .then(() => {
                    this.list$()
                })
                .catch((response) => {
                    alertService.error(this.$t('guest.global.error'), response.message);
                }).finally(() => {
                    this.$emit("updatePageClose");
                    alertService.close();
                });
            }
            alertService.confirmation(callback, this.$t('guest.setting.are-you-sure-car'), this.$t('guest.setting.cant-be-revert-car'));
        },
        showModal(data) {
            this.error = null
            this.car = {
                lang: this.$i18n.locale
            }
            if(data) {
                this.car = {
                    region: data.region,
                    sort_number: data.sort_number,
                    hiragana: data.hiragana,
                    registered_number: data.registered_number,
                    id: data.id,
                    lang: this.$i18n.locale
                }
            }
            this.$bvModal.show('car-modal')
        },
        hideModal() {
            this.car = {}
            this.$bvModal.hide('car-modal')
        },
    }
}
